import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  InputGroupText,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate to handle navigation
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
import apiRequest from '../../../api';

const Login = () => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // For storing error messages
  const navigate = useNavigate(); // Initialize navigate to redirect after successful login
 
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    if(!localStorage.getItem('Language'))
      localStorage.setItem('Language', 'EN');
    return localStorage.getItem('Language');
  });
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen);
  useEffect(() => {
    localStorage.setItem('Language', selectedLanguage);
  }, [selectedLanguage]);

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const validationSchema = Yup.object({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = async (values) => {
    try {
      const response = await apiRequest('/api/users/login', 'POST', {
        username: values.username,
        password: values.password,
      });
      //console.log(response.info);
      const { jwt, info,language } = response;//.data;
      sessionStorage.setItem("jwt", jwt); // Store the JWT in localStorage
      sessionStorage.setItem("username", info.username);
      sessionStorage.setItem("email", info.email);

      sessionStorage.setItem("language", language);
      // Navigate based on user role
      if (info.role === "USER") {
        navigate("/home");
      } else if (info.role === "MANAGER") {
        navigate("/admin/parking");
      } else if (info.role === "SECURITY") {
        navigate("/security/parking");
      }
    
    } catch (error) {
      console.log(error);
      if (selectedLanguage === 'EN')
        setErrorMessage("Invalid username or password");
      else
        setErrorMessage("Uneti podaci nisu validni");
    }
  };

  return (
    <Container fluid className="login-container">
      <Row className="h-100">
        <Col md="7" className="login-image d-md-block"></Col>
        <Col md="5" className="form-with-logo d-flex align-items-start align-items-md-center justify-content-center">
          <div className="login-form text-center d-flex flex-column align-items-center">
            <div className="logo mb-5">
              <img
                src="/assets/img/Sirius_logo_blau.jpg"
                className="log-image mb-5"
                width={180}
                alt="Logo"
              />
            </div>

            <Formik
              initialValues={{
                username: "",
                password: "",
              }}

              onSubmit={handleSubmit}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  {/* Username Field */}
                  <FormGroup className="mb-4 position-relative">
                    <div className="input-container position-relative">
                      <Field
                        as={Input}
                        type="text"
                        name="username"
                        placeholder={selectedLanguage === "EN" ? "Username":"Korsničko ime"}
                        className="ps-5 text-start"
                      />
                      <img
                        src="/assets/icons/username.png"
                        width={25}
                        alt="username"
                        className="input-icon"
                      />
                    </div>
                  </FormGroup>

                  {/* Password Field */}
                  <FormGroup className="mb-4 position-relative">
                    <div className="input-container position-relative">
                      <Field
                        as={Input}
                        type={passwordVisible ? "text" : "password"}
                        name="password"
                        placeholder={selectedLanguage === "EN" ? "Password":"Šifra"}
                        className="ps-5 text-start"
                      />
                      <img
                        src="/assets/icons/lock.svg"
                        width={25}
                        alt="password"
                        className="input-icon"
                      />
                      <InputGroupText
                        onClick={togglePasswordVisibility}
                        style={{
                          cursor: "pointer",
                          position: "absolute",
                          right: 0,
                          top: 0,
                          bottom: 0,
                          backgroundColor: "transparent",
                          border: 0,
                        }}
                      >
                        {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                      </InputGroupText>
                    </div>
                  </FormGroup>

                  {/* Error message display */}
                  {errorMessage && (
                    <div className="text-danger mb-3">{errorMessage}</div>
                  )}

                  <Button color="primary" block type="submit" style={{ fontFamily: "jura-light" }}>
                    {selectedLanguage === "EN"?"Login":"Uloguj se"}
                  </Button>
                  
                  <div className="mt-3 d-flex justify-content-between">
                    <p>
                      <Link className="link_auth mx-2" to="/forgot">
                        {selectedLanguage === "EN" ? "Forgot Password?":"Zaboravili ste šifru?"}
                      </Link>
                    </p>
                    {/*
                    <p style={{ fontFamily: "jura-light" }}>
                      Don't have an account?{" "}
                      <Link className="link_auth" to="/register">
                        Register
                      </Link>
                    </p>*/}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
      <Dropdown 
        isOpen={languageDropdownOpen} 
        toggle={toggleLanguageDropdown} 
        className="position-fixed"
        style={{
          bottom: "10px",
          right: "10px",
          zIndex: 1000
        }}
      >
        <DropdownToggle
          caret
          style={{
            backgroundColor: 'transparent',
            color: 'rgba(13, 48, 114, 1)',
            border: '1px solid rgba(13, 48, 114, 1)',
            padding: '2px 15px',
            borderRadius: '5px',
            fontFamily: 'jura-light'
          }}
        >
          {selectedLanguage}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedLanguage('EN')}>EN</DropdownItem>
          <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedLanguage('RS')}>RS</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Container>
  );
};

export default Login;
